// extracted by mini-css-extract-plugin
export default {"brandsSwiper":"brands_brandsSwiper__msd-R","brands":"brands_brands__+H66x"};